import { CustomDataAttrGtmClick } from '../../features/google/customDataType';
import { DefaultProps } from '../../types/DefaultProps';
import { ComponentProps as IconProps } from '../Icon/Icon';

import styles from './HeaderIconButton.module.scss';

import type { FC, ComponentType, ReactNode } from 'react';

type Props = DefaultProps & {
  icon: ComponentType<IconProps>;
  children?: ReactNode;
  link?: string;
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

export const HeaderIconButton: FC<Props> = ({
  icon: Icon,
  children,
  link,
  customDataAttrGtmClick = '',
}) => (
  <a
    className={styles.wrap}
    href={link}
    data-gtm-click={customDataAttrGtmClick}
  >
    <span className={styles['icon-wrap']}>
      <Icon size={24} />
    </span>
    <span className={styles.text}>{children}</span>
  </a>
);
